import React from 'react';

import getEnvironment, { EnvironmentTypes } from '@zola-helpers/client/dist/es/util/environment';

import styles from './errorBoundary.module.less';

interface Props {
  children: React.ReactNode;

  /** Optional logger interface to record the caught error */
  Logger?: {
    error: (args: unknown) => void;
  };

  /** Optional environment override: for storybook mainly */
  environment?: EnvironmentTypes;
}

interface State {
  error: Error | null;
  logged: boolean;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, logged: false };
  }

  componentDidCatch(error: Error): void {
    this.setState({ error });
  }

  render(): React.ReactNode {
    const { error, logged } = this.state;
    const { children, Logger, environment = getEnvironment() } = this.props;

    if (error) {
      if (!logged) {
        Logger && Logger.error(error);
        this.setState({ logged: true });
      }

      if (environment === EnvironmentTypes.PRODUCTION) return <></>;

      return (
        <div data-testid="error-boundary-element" className={styles.error}>
          React Error: {error.message}
        </div>
      );
    }

    return children;
  }
}
